<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="center"><a id="page4"></a><em>To Dan, Abigail, Bryce, Carson, DJ, and Nicole —</em></p>
<p class="center"><em>I cherish you.</em></p>
<p class="center"><em>You are vibrant proof of God’s great love for me,</em></p>
<p class="center"><em>and on the hard days,</em></p>
<p class="center"><em>your presence reminds me why I breathe.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?01af4d46